/* BikeLink – PDP colour swatches: live «Farge: …» label (instant on change, preview on hover). 2026-10-05 */
(function () {
  if (window.__blSwatches) return;
  window.__blSwatches = true;

  function labelFor(el) {
    var fs = el.closest && el.closest('.bl-colour-option');
    return fs ? fs.querySelector('[data-bl-colour-value]') : null;
  }
  function checkedName(fs) {
    var inp = fs.querySelector('input[data-bl-colour-name]:checked');
    if (inp) return inp.getAttribute('data-bl-colour-name');
    var sel = fs.querySelector('.bl-swatch.is-selected');
    return sel ? sel.getAttribute('data-bl-colour-name') : null;
  }

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.matches || !t.matches('.bl-colour-option input[data-bl-colour-name]')) return;
    var lab = labelFor(t);
    if (lab) lab.textContent = t.getAttribute('data-bl-colour-name');
  });

  document.addEventListener('mouseover', function (e) {
    var sw = e.target.closest && e.target.closest('.bl-swatch[data-bl-colour-name]');
    if (!sw) return;
    var lab = labelFor(sw);
    if (lab) lab.textContent = sw.getAttribute('data-bl-colour-name');
  });
  document.addEventListener('mouseout', function (e) {
    var sw = e.target.closest && e.target.closest('.bl-swatch[data-bl-colour-name]');
    if (!sw || (e.relatedTarget && sw.contains(e.relatedTarget))) return;
    var fs = sw.closest('.bl-colour-option');
    var lab = labelFor(sw);
    var n = fs && checkedName(fs);
    if (lab && n) lab.textContent = n;
  });

  /* On the product page the size modal's "Se størrelse og geometri" link points to #finn-storrelse on the same page:
     close the modal so the page can scroll to the geometry section. */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('#bl-size-modal [data-bl-size-product-link]');
    if (!a || (a.getAttribute('href') || '').charAt(0) !== '#') return;
    var bd = document.querySelector('#bl-size-modal [data-bl-size-close]');
    if (bd) bd.click();
  });
})();
